/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wf_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Word Counter totals words, characters, and sentences. This tool breaks down which individual words appear most often — useful for keyword density and writing analysis.`)
};

const es_wf_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El Contador de Palabras totaliza palabras, caracteres y oraciones. Esta herramienta desglosa qué palabras individuales aparecen más a menudo — útil para la densidad de palabras clave y el análisis de escritura.`)
};

const de_wf_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Wortzähler zählt Wörter, Zeichen und Sätze insgesamt. Dieses Tool schlüsselt auf, welche einzelnen Wörter am häufigsten vorkommen — nützlich für die Keyword-Dichte und die Textanalyse.`)
};

const nl_wf_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De Woordteller telt woorden, tekens en zinnen. Dit hulpmiddel breekt af welke afzonderlijke woorden het meest voorkomen — nuttig voor trefwoorddichtheid en schrijfanalyse.`)
};

const fr_wf_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le compteur de mots totalise les mots, caractères et phrases. Cet outil détaille quels mots individuels apparaissent le plus souvent — utile pour la densité des mots-clés et l'analyse de l'écriture.`)
};

const it_wf_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il Contatore di parole totalizza parole, caratteri e frasi. Questo strumento scompone quali parole individuali appaiono più spesso — utile per la densità delle parole chiave e l'analisi della scrittura.`)
};

const pt_br2_wf_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Word Counter totaliza palavras, caracteres e frases. Esta ferramenta decompõe quais palavras individuais aparecem com mais frequência — útil para análise de densidade de palavras-chave e escrita.`)
};

const pt_wf_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Contador de Palavras totaliza palavras, caracteres e frases. Esta ferramenta decompõe quais palavras individuais aparecem mais vezes — útil para densidade de palavras-chave e análise de escrita.`)
};

const ja_wf_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語カウンターは単語、文字、および文をカウントします。このツールは、どの個別の単語が最も頻繁に出現するかを分解します—キーワード密度と執筆分析に役立ちます。`)
};

const zh_wf_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单词计数器统计的是单词、字符和句子的总数。而这个工具会细分出哪些具体单词出现频率最高——适用于关键词密度检查和写作分析。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wf_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wf_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wf_faq1_a", locale)
	if (locale === "en") return en_wf_faq1_a(inputs)
	if (locale === "es") return es_wf_faq1_a(inputs)
	if (locale === "de") return de_wf_faq1_a(inputs)
	if (locale === "nl") return nl_wf_faq1_a(inputs)
	if (locale === "fr") return fr_wf_faq1_a(inputs)
	if (locale === "it") return it_wf_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_wf_faq1_a(inputs)
	if (locale === "pt") return pt_wf_faq1_a(inputs)
	if (locale === "ja") return ja_wf_faq1_a(inputs)
	return zh_wf_faq1_a(inputs)
};